<div class="image-container" style="overflow:hidden;">
	<!-- Header Controls -->
	<div class="navbar navbar-default">
	  <div class="container-fluid">
	    <div class="text-center">
	    
	      <div class="btn-group">
		      <button class="btn btn-default btn-sm navbar-btn" (click)="reset()" title="{{LOCALIZATION.center}}">
		        <i class="fas fa-crosshairs"></i>
		      </button>
	      </div>
	 
	<!--  TODO      -->
	<!--             <div class="btn-group-vertical" style="position:absolute;bottom:5px;right:5px"> -->
	<!--                 <button *ngIf='$parent.sliderOn && $parent.docPerm === "cart"' id='viewer_pageCart' class="visible-xs btn btn-sm btn-info ng-scope" (click)='$parent.addPageToCart()'> <span class="fas fa-shopping-cart"></span> {{LOCALIZATION.addPageToCart}} - {{$parent.pages[$parent.selectedPage].amount  | currency : symbol : fractionSize}}</button> -->
	<!--                 <button *ngIf='$parent.sliderOn && $parent.docPerm === "cart"' id='viewer_documentCart' class="visible-xs btn btn-sm btn-info ng-scope" (click)='$parent.addDocumentToCart()'> <span class="fas fa-shopping-cart"></span> {{LOCALIZATION.addDocToCart}} - {{$parent.amount  | currency : symbol : fractionSize}}</button> -->
	<!--             </div> -->     
	      
	      <div class="btn-group">
		      <button class="btn btn-default btn-sm navbar-btn" (click)="zoom(true)" title="{{LOCALIZATION.zoomIn}}">
		        <i class="fas fa-search-plus"></i>
		      </button>
		      <button class="btn btn-default btn-sm navbar-btn" (click)="zoom(false)" title="{{LOCALIZATION.zoomOut}}">
		        <i class="fas fa-search-minus"></i>
		      </button>
	      </div>
	      
	      <div class="btn-group">
		      <button class="btn btn-default btn-sm navbar-btn" (click)="rotate()" title="{{LOCALIZATION.rotate}}">
		        <i class="fas fa-sync"></i>
		      </button>
	      </div>
	      
	      <div class="btn-group">
		      <button class="btn btn-default btn-sm navbar-btn" (click)="scaleX()" title="{{LOCALIZATION.flipHorizontal}}">
		        <i class="fas fa-arrows-alt-h"></i>
		      </button>
		      <button class="btn btn-default btn-sm navbar-btn" (click)="scaleY()" title="{{LOCALIZATION.flipVertical}}">
		        <i class="fas fa-arrows-alt-v"></i>
		      </button>
	      </div>
	      
	      <div class="btn-group">
		      <button class="btn btn-default btn-sm navbar-btn" (click)="move(0, -10)" title="{{LOCALIZATION.moveUp}}">
		        <i class="fas fa-chevron-up"></i>
		      </button>
		      <button class="btn btn-default btn-sm navbar-btn" (click)="move(0, 10)" title="{{LOCALIZATION.moveDown}}">
		        <i class="fas fa-chevron-down"></i>
		      </button>
		      <button class="btn btn-default btn-sm navbar-btn" (click)="move(-10, 0)" title="{{LOCALIZATION.moveLeft}}">
		        <i class="fas fa-chevron-left"></i>
		      </button>
		      <button class="btn btn-default btn-sm navbar-btn" (click)="move(10, 0)" title="{{LOCALIZATION.moveRight}}">
		        <i class="fas fa-chevron-right"></i>
		      </button>
	      </div>
	      
	      <div class="btn-group" *ngIf="chippingEnabled">
		      <button *ngIf='chipOn' class="btn btn-default btn-sm navbar-btn" (click)="toggleChipPanel()" title="{{LOCALIZATION.chip}}">
		        <i class="fas fa-crop-alt"></i>
		      </button>
	      </div> 
	      
	      <div class="btn-group" *ngIf='projectionEnabled'>
             <!-- GEOTIFF: Launch the projected image in a map. See KV-2930 -->
		      <button class="btn btn-default btn-sm navbar-btn" (click)="projectImage()" title="{{LOCALIZATION.viewProjected}}" 
		      	      *ngIf="documentData['projected'] || documentData['projectedPages']?.length > 0">
		        <i class="fa fa-eye"></i>
		      </button>
	      </div>
	      	           
	    </div>
	  </div>
	</div>
	
	<!-- Content -->
	<!-- Height is calculated by subtracting the navbar height -->
	<div class="imageViewerFocus" [ngClass]="{panelOn : panelOn, 'mobile-view': (isMobile && panelOn)}" style="width:100%; height:calc(100% - 52px); margin-top:0;">
	
	  <angular-cropper #angularCropper
	    [cropperOptions]="cropperConfig"
	    [imageUrl]="viewerURL">
	  </angular-cropper>

	</div>
</div>

<!-- Chipping panel -->
<div id='imageViewerPanel' class='viewerPanel' [ngClass]='{hide : !panelOn, "mobile-view": isMobile}'>
       <div class="text-center viewer-panel-header"><h3 style='margin:10px'>{{LOCALIZATION.chipping}}</h3></div>
       <br>
       <form class="form text-center">
           <div class="btn-group">
               <button type="button" class="btn btn-default" title="{{LOCALIZATION.clear}}" (click)="clear()"><i class="fas fa-times"></i></button>
               <button type="button" class="btn btn-default btn-primary" title="{{LOCALIZATION.crop}}" (click)="toggleCropBox()"><i class="fas fa-crop-alt"></i></button>
           </div>
       </form>
       <br>
       <form class="form-horizontal">
           <div class="form-group col-xs-6">
               <label class="col-xs-3 control-label">y1</label>
               <div class="col-xs-9">
                   <input class="form-control" type="text" [(ngModel)]="chip.minY" name="minY" disabled />
               </div>
           </div>
           <div class="form-group col-xs-6">
               <label class="col-xs-3 control-label">x1</label>
               <div class="col-xs-9">
                   <input class="form-control" type="text" [(ngModel)]="chip.minX" name="minX" disabled />
               </div>
           </div>
       </form>
       <form class="form-horizontal">
           <div class="form-group col-xs-6">
               <label class="col-xs-3 control-label">y2</label>
               <div class="col-xs-9">
                   <input class="form-control" type="text" [(ngModel)]="chip.maxY" name="maxY" disabled />
               </div>
           </div>
           <div class="form-group col-xs-6">
               <label class="col-xs-3 control-label">x2</label>
               <div class="col-xs-9">
                   <input class="form-control" type="text" [(ngModel)]="chip.maxX" name="maxX" disabled />
               </div>
           </div>
       </form>
       <form >
           <div class="form-group col-xs-12">
               <label>{{LOCALIZATION.chipFormat}}</label>
               <div>
				<select class="form-control" [(ngModel)]="chip.chipFormat" name="chipFormat">
				  <option *ngFor="let format of supportedChipFormats" [ngValue]="format.value">{{ format.display }}</option>
				</select>
               </div>
           </div>
       </form>
       <br>
       <form>
           <div class="form-group col-xs-12">
               <label>{{LOCALIZATION.chipRequestName}}</label>
               <input class="form-control" type="text" [(ngModel)]="chip.chipRequestName" name="chipRequestName" placeholder="Request name" />
           </div>
       </form>
       <br>
       <form *ngIf="userPermissions['ROLE_USERS_EMAIL']">
           <div class="form-group col-xs-12">
               <label>
                   <input type="checkbox" [(ngModel)]="chip.chipEmailNotification" name="chipEmailNotification" /> {{LOCALIZATION.emailSend}}
               </label>
           </div>
       </form>
       <br>
       <form>
           <div class="form-group col-xs-12">
               <button class="btn btn-primary" (click)="performChip()">{{LOCALIZATION.chip}}</button>
           </div>
       </form>	
</div>
